import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from "./home/home.component";
import {TrackingResultComponent} from "./tracking-result/tracking-result.component";
import {TrackingResultResolver} from "./tracking-result/tracking-result.resolver.service";
import {SettingsComponent} from "./settings/settings.component";
import {authGuard} from "./guards/auth.guard";

const routes: Routes = [
  {
    path: "home",
    component: HomeComponent,
  }, {
    path: "settings",
    component: SettingsComponent,
    canActivate: [authGuard],
  }, {
    path: "search/:searchString",
    component: TrackingResultComponent,
    resolve: {trackingResult: TrackingResultResolver},
  }, {
    path: "**",
    redirectTo: "home",
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
